import React, { useState, useEffect } from "react";

export const svg = `<svg width="28" height="28" viewbox="0 0 28 28"><path fill-rule="evenodd" d="M9.36 17.688 9.122 16.5l-3.02-1.712a2.227 2.227 0 0 1-1.185-1.574l-.879-4.57a2.227 2.227 0 0 1 2.188-2.642H7.49A1.635 1.635 0 0 1 9.001 5h10c.689 0 1.262.42 1.508 1h1.261a2.227 2.227 0 0 1 2.188 2.642l-.871 4.57a2.227 2.227 0 0 1-1.185 1.574l-3.02 1.71-.241 1.192A1.636 1.636 0 0 1 17.037 19h-.905a.5.5 0 0 0-.495.574l.15 1a.5.5 0 0 0 .495.426h1.279a.5.5 0 0 1 .332.126l1.125 1a.5.5 0 0 1-.332.874h-9.37a.5.5 0 0 1-.332-.874l1.125-1A.5.5 0 0 1 10.44 21h1.28a.5.5 0 0 0 .494-.426l.15-1A.5.5 0 0 0 11.87 19h-.905c-.779 0-1.45-.549-1.604-1.313ZM6.226 8.002h1.382l1.003 5.965L7 13.003a.227.227 0 0 1-.12-.16L6 8.272a.227.227 0 0 1 .224-.27ZM21.77 8h-1.375l-1.002 5.961L21.001 13a.228.228 0 0 0 .121-.16l.872-4.57A.227.227 0 0 0 21.77 8Zm-7.902 5.085a.286.286 0 0 1 .265 0l1.684.882c.21.11.454-.068.414-.301L15.91 11.8a.285.285 0 0 1 .082-.254l1.36-1.32a.286.286 0 0 0-.158-.487l-1.88-.272a.286.286 0 0 1-.216-.156l-.842-1.7a.286.286 0 0 0-.511 0l-.842 1.7a.286.286 0 0 1-.215.156l-1.88.272a.286.286 0 0 0-.159.487l1.36 1.32c.067.066.098.16.082.254l-.321 1.865a.286.286 0 0 0 .414.301l1.684-.882Z" clip-rule="evenodd"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
